// removed by extract-text-webpack-plugin
module.exports = {"chevron":"_2Acl_nSA2ubdlUp-AL7faX","right":"_2QJy289bFE_s3w-itKX5qJ","bottom":"_2oLPduMUW6IlqY9BRnwGz3","left":"_103Od7RGCgXbZnknGvOzg-"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Chevron/styles.scss
// module id = 615
// module chunks = 11